// import store from '@/store';
// import moment from "moment";
import consts from "@/consts";

const defaultSetRoute = {
    units: (route, router) => {
        if(route.meta?.mainRouteName !== consts.routerNames.units.main) {
            if(consts.app.$isDevelopment) console.warn('units', route);
            return false
        }
        router.push({
            name: consts.routerNames.units.main,
            params: {},
            query: {}
        })
    },
    unitsEdit: (route, router, unitId) => {
        if(route.meta?.mainRouteName !== consts.routerNames.units.main) {
            if(consts.app.$isDevelopment) console.warn('unitsEdit', route);
            return false
        }
        router.push({
            name: consts.routerNames.units.edit.main,
            params: {
                unitId,
            },
            query: {...route.query}
        })
    },
    unitsCreate: (route, router) => {
        if(route.meta?.mainRouteName !== consts.routerNames.units.main) {
            if(consts.app.$isDevelopment) console.warn('unitsCreate', route);
            return false
        }
        router.push({
            name: consts.routerNames.units.edit.create,
            params: {
            },
            query: {...route.query}
        })
    },
    unitsHistory: (route, router, unitId) => {
        if(route.meta?.mainRouteName !== consts.routerNames.units.main) {
            if(consts.app.$isDevelopment) console.warn('unitsHistory', route);
            return false
        }
        router.push({
            name: consts.routerNames.units.history,
            params: {
                unitId
            },
            query: {...route.query}
        })
    },
    unitsSensorEdit: (route, router, unitId, sensorId) => {
        if(route.meta?.mainRouteName !== consts.routerNames.units.main) {
            if(consts.app.$isDevelopment) console.warn('unitsSensorEdit', route);
            return false
        }
        router.push({
            name: consts.routerNames.units.sensors.edit,
            params: { unitId, sensorId },
            query: {...route.query}
        })
    },
    unitsSensorCreate: (route, router, unitId) => {
        if(route.meta?.mainRouteName !== consts.routerNames.units.main) {
            if(consts.app.$isDevelopment) console.warn('unitsSensorCreate', route);
            return false
        }
        router.push({
            name: consts.routerNames.units.sensors.create,
            params: { unitId },
            query: {...route.query}
        })
    },
}

const routes = (process.env.VUE_APP_PACKAGE !== 'prometheus.admin') ? [] : [
    {
        path: 'units',
        name: consts.routerNames.units.main,
        meta: {
            mainRouteName: consts.routerNames.units.main,
            bodyGrid: "1X1",
            showHead: true,
            setRoute: defaultSetRoute,
        },
        component: () => import('@/views/prometheus/admin/UnitsPage.vue'),
        children: [
            {
                path: ':unitId(\\d+)/edit',
                name: consts.routerNames.units.edit.main,
                meta: {
                    blockingRoutesTransitionFromOutside: true,
                    sectionInfoByRoute: true,
                },
                props: {
                    sectionInfoByRoute: (route) => ({
                        unitId: +route.params.unitId,
                        wrapper: 'EditSegmentControl_vertical',
                        time: Date.now(),
                    })
                },
                components: {
                    sectionInfoByRoute: () => import('@/components/units/unit-edit/UnitEdit.vue'),
                },
            },
            {
                path: 'create',
                name: consts.routerNames.units.edit.create,
                meta: {
                    blockingRoutesTransitionFromOutside: true,
                    sectionPopupByRoute: {
                        SectionWrapByRoutePopup: {
                            // class: 'popup-full',
                            titlePosition: 'center'
                        }
                    }
                },
                props: {
                    sectionPopupByRoute: () => ({
                        wrapper: 'EditWizard',
                        class: 'popup-body',
                    })
                },
                components: {
                    sectionPopupByRoute: () => import('@/components/units/unit-edit/UnitEdit.vue'),
                }
            },
            {
                path: ':unitId(\\d+)/sensors/:sensorId(\\d+)/edit',
                name: consts.routerNames.units.sensors.edit,
                meta: {
                    sectionPopupByRoute: {
                        SectionWrapByRoutePopup: {
                            titlePosition: 'center'
                        }
                    }
                },
                props: {
                    sectionPopupByRoute: (route) => ({
                        unitId: +route.params.unitId,
                        sensorId: +route.params.sensorId,
                    })
                },
                components: {
                    sectionPopupByRoute: () => import('@/components/units/sensors/UnitSensorEditPage.vue'),
                }
            },
            {
                path: ':unitId(\\d+)/sensors/create',
                name: consts.routerNames.units.sensors.create,
                meta: {
                    sectionPopupByRoute: {
                        SectionWrapByRoutePopup: {
                            titlePosition: 'center'
                        }
                    }
                },
                props: {
                    sectionPopupByRoute: (route) => ({
                        unitId: +route.params.unitId,
                        sensorId: null,
                    })
                },
                components: {
                    sectionPopupByRoute: () => import('@/components/units/sensors/UnitSensorEditPage.vue'),
                }
            },
            {
                path: ':unitId(\\d+)/history',
                name: consts.routerNames.units.history,
                meta: {
                    sectionPopupByRoute: {
                        SectionWrapByRoutePopup: {
                            class: 'popup-full',
                            titlePosition: 'left'
                        }
                    }
                },
                props: {
                    sectionPopupByRoute: (route) => ({
                        objectName: 'unit',
                        objectId: +route.params.unitId,
                    })
                },
                components: {
                    sectionPopupByRoute: () => import('@/components/objects_audit/objects/ObjectsChangesTableTreeList.vue'),
                }
            }
        ]
    },
];

export default routes;